module.exports = __webpack_public_path__ + "img/img_kf_kf01.dcf633ee.webp";